import React, { useState, useEffect } from 'react';
import { Phone, MessageCircle, Clock, X } from 'lucide-react';
import { contactInfo } from '../data/mock';

const UrgencyBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    return () => clearTimeout(timer);
  }, []);

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 bg-gradient-to-r from-amber-600 to-amber-500 text-black py-3 sm:py-4 px-4 shadow-lg">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
        <div className="flex items-center space-x-3">
          <Clock className="w-5 h-5 sm:w-6 sm:h-6 animate-pulse" />
          <p className="font-bold text-sm sm:text-base text-center sm:text-left">
            <span className="hidden sm:inline">Votre ex peut revenir en 24-72h !</span>
            <span className="sm:hidden">Ex revient en 24-72h !</span>
            <span className="font-normal ml-2">Contactez-nous maintenant</span>
          </p>
        </div>
        <div className="flex items-center space-x-3">
          <a
            href={`tel:${contactInfo.phone.replace(/\s/g, '')}`}
            className="flex items-center px-4 py-2 bg-black text-amber-500 font-bold text-sm rounded-full hover:bg-gray-900 transition-colors"
          >
            <Phone className="w-4 h-4 mr-2" />
            <span className="hidden sm:inline">{contactInfo.phone}</span>
            <span className="sm:hidden">Appeler</span>
          </a>
          <a
            href={contactInfo.whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center px-4 py-2 bg-green-600 text-white font-bold text-sm rounded-full hover:bg-green-700 transition-colors"
          >
            <MessageCircle className="w-4 h-4 mr-2" />
            WhatsApp
          </a>
          <button
            onClick={() => setIsVisible(false)}
            className="p-2 hover:bg-amber-400 rounded-full transition-colors"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default UrgencyBanner;
